var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import { Box, Button, TextField } from '@mui/material';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { CREATE_NOTIFICATION_TEMPLATE } from 'common/graphql/mutations/notification/create-notification-template';
import { NOTIFICATION_TEMPLATES } from 'common/graphql/queries/notification/notification-templates';
import useDynamicMutation from 'common/hooks/useDynamicMutation';
import { notificationTemplateCreateValidationSchema } from 'common/validationSchemas/notificationTemplateValidationSchema';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/actions';
var NotificationTemplateAddNew = function () {
    var _a = useState(undefined), file = _a[0], setFile = _a[1];
    var _b = useState(false), isAddNew = _b[0], setIsAddNew = _b[1];
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var createNotificationTemplate = function (data) {
        return useMutation(CREATE_NOTIFICATION_TEMPLATE, {
            variables: {
                createNotificationTemplateData: {
                    name: data === null || data === void 0 ? void 0 : data.name,
                    description: data === null || data === void 0 ? void 0 : data.description
                },
                templateFile: data === null || data === void 0 ? void 0 : data.file
            },
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: NOTIFICATION_TEMPLATES
                },
            ]
        });
    };
    var onSuccess = function () {
        dispatch(openSnackbar({
            message: "\u0428\u0430\u0431\u043B\u043E\u043D \u0441\u043E\u0445\u0440\u0430\u043D\u0451\u043D",
            severity: SnackbarSeverity.SUCCESS
        }));
        setFile(undefined);
        setIsAddNew(false);
    };
    var onError = function (_a) {
        var code = _a.code;
        dispatch(openSnackbar({
            message: code,
            severity: SnackbarSeverity.ERROR
        }));
    };
    var handleExecuteMutation = useDynamicMutation(createNotificationTemplate, onSuccess, onError).handleExecuteMutation;
    var handleReset = function () {
        setIsAddNew(false);
        formik.resetForm();
    };
    var handleSubmit = function (data) {
        if (!file) {
            onUploadMessage({
                code: t("\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u043E\u0434\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0444\u0430\u0439\u043B \u0448\u0430\u0431\u043B\u043E\u043D\u0430!")
            });
            return;
        }
        handleExecuteMutation(__assign(__assign({}, data), { file: file }));
        formik.resetForm();
    };
    var handleChangeWrapper = function (e) {
        formik.setFieldError(e.target.name, undefined); // <- reset error on the field
        formik.handleChange(e); // <- call original Formik's change handler
    };
    var formik = useFormik({
        initialValues: { name: '', description: '' },
        validationSchema: notificationTemplateCreateValidationSchema,
        onSubmit: handleSubmit,
        validateOnChange: false,
        validateOnBlur: false
    });
    var onUploadMessage = function (_a) {
        var code = _a.code, severity = _a.severity;
        dispatch(openSnackbar({
            message: code,
            severity: severity || SnackbarSeverity.ERROR
        }));
    };
    var handleCapture = function (event) {
        var files = event.target.files;
        if (files.length) {
            if (files.length > 1) {
                onUploadMessage({
                    code: t("\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 1")
                });
                return;
            }
            var errorFiles_1 = [];
            Array.from(files).forEach(function (file) {
                if (file.size > 50000000) {
                    errorFiles_1.push(file.name);
                    return;
                }
            });
            if (errorFiles_1.length) {
                onUploadMessage({
                    code: t("\u0420\u0430\u0437\u043C\u0435\u0440 \u0444\u0430\u0439\u043B\u0430 \u043D\u0435 \u0434\u043E\u043B\u0436\u0435\u043D \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0442\u044C") + " 50Mb"
                });
            }
            else {
                setFile(files[0]);
            }
        }
    };
    return (_jsx(Box, __assign({ sx: { width: '100%' } }, { children: isAddNew ? (_jsxs("form", __assign({ className: "flex flex-col space-y-10 pt-20", onSubmit: formik.handleSubmit, onReset: formik.handleReset }, { children: [_jsxs("div", __assign({ className: "flex xs:flex-col md:flex-row xs:space-y-20 xs:space-x-0 md:space-x-20 md:space-y-0 w-full items-center" }, { children: [_jsx(TextField, { className: "w-full", label: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435", multiline: true, autoFocus: true, name: "name", value: formik.values['name'], onChange: handleChangeWrapper, error: Boolean(formik.errors['name']), helperText: formik.errors['name'] }, void 0), _jsx(TextField, { className: "w-full", label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435", autoFocus: true, name: "description", value: formik.values['description'], onChange: handleChangeWrapper, error: Boolean(formik.errors['description']), helperText: formik.errors['description'] }, void 0), _jsxs("div", __assign({ className: "flex flex-col space-y-5" }, { children: [_jsxs("div", __assign({ className: "min-w-320" }, { children: [_jsx("input", { accept: ".hbs", className: "hidden", id: "button-file", multiple: false, type: "file", name: "upload", onChange: handleCapture }, void 0), _jsx("label", __assign({ htmlFor: "button-file" }, { children: _jsx("span", __assign({ className: "tw-btn upload-file cursor-pointer" }, { children: t('Выбрать файл шаблона') }), void 0) }), void 0)] }), void 0), file && _jsx("p", { children: file.name }, void 0)] }), void 0)] }), void 0), _jsxs("div", __assign({ className: "flex flex-row space-x-10" }, { children: [_jsx(Button, __assign({ type: "reset", color: "secondary", onClick: function () { return handleReset(); } }, { children: t('Отмена') }), void 0), _jsx(Button, __assign({ type: "submit" }, { children: t('Сохранить') }), void 0)] }), void 0)] }), void 0)) : (_jsx(Button, __assign({ type: "submit", onClick: function () { return setIsAddNew(true); } }, { children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C" }), void 0)) }), void 0));
};
export default NotificationTemplateAddNew;
